import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onClick"];

var _Button, _CaretDown;

import React, { forwardRef, useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CaretDown } from '@resultadosdigitais/tangram-react-icons';
import DropdownMenuContext from './DropdownMenuContext';
import { isFunction } from '../helper';
import { useMergeRefs } from '../hooks';
import Link from '../Link';
import Button from '../Button';

const resolveChildren = children => {
  const count = React.Children.count(children);

  if (!count) {
    return _Button || (_Button = /*#__PURE__*/React.createElement(Button, {
      endIcon: /*#__PURE__*/React.createElement(CaretDown, {
        title: "expandable icon",
        titleId: "expandableIconId"
      })
    }));
  }

  if (count > 1 || typeof children === 'string') {
    return /*#__PURE__*/React.createElement(Button, {
      endIcon: _CaretDown || (_CaretDown = /*#__PURE__*/React.createElement(CaretDown, {
        title: "expandable icon",
        titleId: "expandableIconId"
      }))
    }, children);
  }

  if (typeof children === 'object' && children.type === Link && !children.props.href) {
    return /*#__PURE__*/React.cloneElement(children, {
      href: ''
    });
  }

  return children;
};

const DropdownMenuTrigger = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    onClick
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  const {
    toggle,
    setTriggerElement,
    isOpen,
    id
  } = useContext(DropdownMenuContext);
  const triggerRef = useRef();
  useEffect(() => {
    setTriggerElement(triggerRef.current);
  }, [setTriggerElement]);
  return /*#__PURE__*/React.cloneElement(resolveChildren(children), Object.assign({}, rest, {
    onClick: event => {
      event.preventDefault();
      toggle();
      isFunction(onClick) && onClick(event);
    },
    'aria-expanded': isOpen,
    'aria-haspopup': true,
    role: 'menuitem',
    ref: useMergeRefs([triggerRef, ref]),
    id
  }));
});
DropdownMenuTrigger.displayName = 'DropdownMenu.Trigger';
process.env.NODE_ENV !== "production" ? DropdownMenuTrigger.propTypes = {
  /**
   * Sets the children element
   */
  children: PropTypes.node
} : void 0;
export default DropdownMenuTrigger;